import { SimpleGrid, Stack } from "@sveabank/cc-common";
import type {
	BeneficialOwner,
	ForeignBeneficialOwner,
} from "../../../../types/beneficial-ownership";
import BeneficialOwnerItem from "./beneficial-owner-item";

type Props = {
	beneficialOwners: BeneficialOwner[];
	foreignBeneficialOwners: ForeignBeneficialOwner[];
};

const BeneficialOwnerExists = ({ beneficialOwners, foreignBeneficialOwners }: Props) => (
	<Stack gap={2} fullSize>
		<SimpleGrid cols={2}>
			{
				// TODO Can we combine both bo's, while keeping type safety?
				beneficialOwners.map((bo) => (
					<BeneficialOwnerItem bo={bo} key={bo.nationalId} id={bo.nationalId} />
				))
			}
			{foreignBeneficialOwners.map((bo) => (
				<BeneficialOwnerItem
					bo={bo}
					key={bo.personIdentifier.personKey || bo.firstName + bo.lastName}
					id={bo.personIdentifier.dateOfBirth || bo.personIdentifier.personKey}
				/>
			))}
		</SimpleGrid>
	</Stack>
);

export default BeneficialOwnerExists;
